(() => {
  const stickyCart = document.querySelector('[data-sticky-add-to-cart]');
  if (!stickyCart) return;

  const form = document.getElementById(stickyCart.dataset.productFormId) || document.querySelector('form[action*="/cart/add"]');
  const variantInput = form?.querySelector('[name="id"]');
  const submitButton = stickyCart.querySelector('[data-sticky-submit]');
  const priceElement = stickyCart.querySelector('[data-sticky-price]');
  const variants = JSON.parse(stickyCart.dataset.variants || '[]');

  if (!form || !variantInput || !submitButton) return;

  const update = () => {
    const variant = variants.find((item) => String(item.id) === String(variantInput.value));
    if (!variant) return;

    if (priceElement && variant.price) {
      priceElement.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
        style: 'currency',
        currency: 'INR',
        maximumFractionDigits: 2
      }).format(variant.price / 100);
    }

    submitButton.disabled = !variant.available;
    submitButton.textContent = variant.available ? 'Add to cart' : 'Sold out';
  };

  submitButton.addEventListener('click', () => {
    if (!submitButton.disabled) form.requestSubmit();
  });

  form.addEventListener('change', update);
  new MutationObserver(update).observe(variantInput, { attributes: true, attributeFilter: ['value'] });
  update();
})();
